import * as React from 'react';
import { styled } from '@mui/material/styles';
import StarIcon from '@mui/icons-material/Star';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Btn1, Btn2, HeadingText, MyTextField } from '../StyledComponents';
import { Link } from 'react-router-dom';



const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<StarIcon sx={{ fontSize: '0.9rem', color: "white" }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function Faqs() {
    const [expanded, setExpanded] = React.useState('panel1');

    const [selected, setSelected] = React.useState(0);

    const [que,setQue]=React.useState("");

    const theme=useTheme();

    

    let details = [ 
        {
            que: "Who are you?",
            ans: <Box>
                <Typography>
                    I am a dedicated Full-Stack Developer with expertise in creating dynamic, user-centric web applications. My core skills lie in the MERN stack (MongoDB, Express, React, Node.js), where I build both the front-end and back-end systems to deliver seamless, responsive, and scalable solutions.<br /><br />I'm driven by a passion for technology and problem-solving, constantly seeking to improve and adapt in an ever-evolving industry. My goal is to bring ideas to life through code, ensuring every project I work on is both functional and impactful.
                </Typography>
            </Box>,
            panel: "panel1"

        },
        {
            que: "What technologies are you proficient in?",
            ans:<Box>
                    <Typography>
                        I am skilled in a wide range of technologies, including:
                        <dl>
                            <dt>Front End:</dt>
                            <dd>
                                <li>
                                    HTML, CSS, JavaScript, React, Bootstrap, Material-UI (MUI)
                                </li>
                            </dd>
                            <dt>Back End:</dt>
                            <dd>
                                <li>
                                    Node.js, Express, and MongoDB.
                                </li>
                            </dd>
                            <dt>Additional Skills:</dt>
                            <dd>
                                <li>
                                    Java, SQL, Git & GitHub, Visual Studio Code, Eclipse, and Postman.
                                </li>
                            </dd>
                        </dl>
                        
                        
                    </Typography>
                </Box>,
                
            panel: "panel2"
        },
        {
            que: "What is your experience with front-end and back-end development?",
            ans: <Box>
                    <Typography>
                        I specialize in building full-stack applications that deliver seamless user experiences. <br/> <br/>On the front-end, I create responsive, interactive, and user-friendly interfaces using React and Material-UI, ensuring that the UI adapts smoothly across devices. With a keen eye for design, I leverage CSS frameworks like Bootstrap to craft clean, visually appealing layouts that enhance user engagement. <br/><br/>

                        For the back-end, I design and develop RESTful APIs using Node.js and Express, ensuring efficient communication between the client and server. I use MongoDB to manage data, focusing on performance, scalability, and security. My back-end code is modular, well-documented, and built to accommodate growth, making it easy to maintain and expand as projects evolve.
                    </Typography>
                </Box>,
            panel: "panel3"
        },
        {
            que: "Do you have experience working in teams?",
            ans: <Box>
                    <Typography>
                    Yes,<br />
                         I have experience leading and working with developers in collaborative environments. I value clear communication, regular coordination, and enjoy being part of a team where everyone contributes to achieving project goals together.
                    </Typography>
                </Box>,
            panel: "panel4"
        },
        {
            que: "How can I contact you for a project?",
            ans:<Box>
                    <Typography>
                    You can reach me through the Contact section on my portfolio website, where you'll find a form to send a direct message.<br /><br /> Alternatively, feel free to email me at the address provided. I’m always open to discussing new opportunities, collaborations, or any questions you may have!
                    </Typography>
                </Box>,
            panel: "panel5"

        },
        {
            que: "Are you available for hire, and what kind of roles are you interested in?",
            ans: <Box>
                    <Typography>
                    Yes, <br />I am available for hire and open to full-time, part-time, or contract-based roles. I’m particularly interested in roles where I can work on innovative projects, collaborate with diverse teams, and make meaningful contributions to the success of the company.
                    </Typography>
                </Box>,
            panel: "panel6"

        },
        
        {
            que: "My Questions isn't listed here!",
            ans:
                <Box>
                    <Typography mb={1}>
                        If your question wasn't covered, I'd love to hear from you! Click the button below, and you’ll be redirected to a form where you can fill in your details and ask your specific question. I'll get back to you as soon as possible!
                    </Typography>
                    <Btn2
                        component={Link}
                        to="?section=contact"
                        sx={{
                            width: "100%",
                            '&:after': {
                                height: "100%"
                            },
                            '&:hover:after': {
                                height: "0%"
                            }

                        }}
                    >
                        Click here
                    </Btn2>
                </Box>,
            panel: "panel7"

        },

    ]

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    function handleAccordion(ind) {
        setSelected(ind);
    }
    return (
        <Box mt={5} mb={15}>
            <Box
                data-aos="fade-up" data-aos-duration="2000"
                my={5}
            >
                <HeadingText text="FAQ\'S" variant='h1' >
                    FAQ'S
                </HeadingText>  
            </Box>
            <Box 
                display={{ xs: "block", sm: "none"}}
                data-aos="fade-up" data-aos-duration="2000"
            >
                <Typography variant='h6' fontWeight="bold" pb={2}>
                    FAQs
                </Typography>
                {
                    details.map((obj, ind) => {
                        return (
                            <Accordion expanded={expanded === obj.panel} onChange={handleChange(obj.panel)}
                                sx={{
                                    border: "none",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                    backgroundColor: 'transparent'
                                }}
                            >
                                <AccordionSummary aria-controls={`${obj.panel}d-content`} id={`${obj.panel}d-content`}
                                    onClick={() => handleAccordion(ind)}
                                    sx={{
                                        backgroundColor: selected == ind ? 'black' : 'white',
                                        color: selected == ind ? 'white' : 'black',
                                        borderRadius: "10px",
                                        border: `1px solid ${selected == ind?theme.palette.primary.main:"black"}`,
                                    }}
                                >
                                    <Typography>
                                        {obj.que}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails

                                    sx={{
                                        border: "1px solid black",
                                        borderRadius: "15px",
                                        marginBottom: "15px",
                                        backgroundColor: "primary.light",
                                        color:"black"
                                    }}
                                >
                                    <Box>
                                        {obj.ans}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        )
                    })
                }
            </Box>
            <Box 
                display={{ xs: "none", sm: "block" }} 
                data-aos="fade-up" data-aos-duration="2000"
                px={3} 
                sx={{ 
                    border: `2px solid ${theme.palette.text.primary}`, 
                    borderRadius: "15px" 
                }}>
                <Grid container columnSpacing={3}>
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant='h6' fontWeight="bold" pt={4} pb={2}>
                            FAQs
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant='h6' fontWeight="bold" pt={4} pb={2}>
                            Answers
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={3} >
                    <Grid 
                        item
                        xs={12} sm={6} md={6}
                        
                    >

                        {
                            details.map((obj, ind) => {
                                return (
                                    <Accordion expanded={expanded === obj.panel} onChange={handleChange(obj.panel)}
                                        sx={{
                                            border: "none",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "15px",
                                            backgroundColor:'transparent'
                                        }}
                                    >
                                        <AccordionSummary aria-controls={`${obj.panel}d-content`} id={`${obj.panel}d-content`}
                                            onMouseOver={() => handleAccordion(ind)}
                                            sx={{
                                                backgroundColor: selected == ind ? 'black' : 'white',
                                                color: selected == ind ? 'white' : 'black',
                                                borderRadius: "10px",
                                                border: selected == ind ? `2px solid ${theme.palette.primary.main}`:"1px solid black",
                                            }}
                                        >
                                            <Typography>
                                                {obj.que}
                                            </Typography>
                                        </AccordionSummary>

                                    </Accordion>
                                )
                            })
                        }
                    </Grid>
                    <Grid
                        item
                        xs={12} sm={6} md={6}
                        alignContent="center"
                        marginBottom="15px"
                    >

                        {
                            details.map((obj, ind) => {
                                return (
                                    <AccordionDetails
                                        sx={{
                                            border: "1px solid black",
                                            borderRadius: "15px",
                                            // marginBottom:"15px",
                                            backgroundColor:"primary.light",
                                            display: selected == ind ? "block" : "none",
                                            height: "100%",
                                            color:"black",
                                        }}
                                    >
                                        <StarIcon sx={{ fontSize: '0.9rem', color: "primary.main" }} />
                                        <Box>
                                            {obj.ans}
                                        </Box>
                                    </AccordionDetails>
                                )
                            })
                        }
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}